import React from 'react';

const UserGuide = () => {

  return (
    <div>
      <iframe
        title='User Guide'
        src="qc_ug.pdf"
        width="100%"
        height="100%"
        style={{ border: "none", height: "100vh", width: "100vw" }}
      ></iframe>
    </div>
  );
};

export default UserGuide;